import cn from 'classnames';
import { FC, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { useAppSelector } from '@/shared/hooks';
import { SafeHtml, Spinner } from '@/shared/ui';

import { reportsModel } from '@/entities/reports';

import { getEditorContentFromValue } from '../../lib/getEditorContentFromValue';
import { getHTMLWithStyles } from '../../lib/getHTMLWithStyles';

import styles from './PreviewConclusion.module.scss';

type PreviewConclusionProps = {
  className?: string;
};

export const PreviewConclusion: FC<PreviewConclusionProps> = (props) => {
  const { className } = props;
  const [html, setHtml] = useState<string>('');
  const [loading, setLoading] = useState(true);

  const report = useAppSelector(reportsModel.selectors.selectCurrentReport);
  const conclusion = report?.LegacyConclusion || '';

  useEffect(() => {
    const loadContent = async () => {
      try {
        setLoading(true);
        const { stateToHTML } = await import('draft-js-export-html');
        const editorContent = await getEditorContentFromValue(conclusion);
        const htmlWithoutAlign = stateToHTML(editorContent);
        const htmlWithStyles = getHTMLWithStyles(conclusion, htmlWithoutAlign);
        setHtml(htmlWithStyles);
      } catch (error) {
        console.error('Error loading conclusion:', error);
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, [conclusion]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <div
      className={cn(styles.preview, className)}
      data-section="conclusion-preview"
    >
      <h1 className={styles.previewHeader}>
        <FormattedMessage id="report.conclusion" defaultMessage="Conclusion" />
      </h1>
      <div className={styles.legacyConclusion}>
        <SafeHtml html={html} />
      </div>
    </div>
  );
};
